/* eslint-disable */
export const activeClass = {
  methods: {
    activeClassBase(filterName, item) {
      if (item) {
        const totalValue = item.variable;
        let isInBaseGroup;
        if (this.baseGroup[filterName]) {
          isInBaseGroup =
            this.baseGroup[filterName].filter((s) => s.value === totalValue)
              .length > 0
              ? true
              : false;
        } else {
          isInBaseGroup = false;
        }
        if (isInBaseGroup) {
          return "baseGroup";
        }
      }
    },
    activeClassRef(filterName, item) {
      if (item) {
        const totalValue = item.variable;
        let isInRefGroup;
        if (this.referenceGroup[filterName]) {
          isInRefGroup =
            this.referenceGroup[filterName].filter(
              (s) => s.value === totalValue
            ).length > 0
              ? true
              : false;
        } else {
          isInRefGroup = false;
        }
        if (isInRefGroup) {
          return "refGroup";
        }
      }
    },
    activeClass(filterName, item) {
      if (item) {
        let totalValue = "";
        if (item.variable === undefined) {
          totalValue = item.value;
        } else {
          totalValue = item.variable;
        }
        let isInBaseGroup;
        let isInRefGroup;
        if (this.baseGroup[filterName]) {
          isInBaseGroup =
            this.baseGroup[filterName].filter((s) => s.value === totalValue)
              .length > 0
              ? true
              : false;
        } else {
          isInBaseGroup = false;
        }
        if (this.referenceGroup[filterName]) {
          isInRefGroup =
            this.referenceGroup[filterName].filter(
              (s) => s.value === totalValue
            ).length > 0
              ? true
              : false;
        } else {
          isInRefGroup = false;
        }
        if (isInBaseGroup && isInRefGroup) {
          return "isInBothGroups";
        } else if (isInBaseGroup) {
          return "isInBaseGroup";
        } else if (isInRefGroup) {
          return "isInRefGroup";
        } else {
          return "";
        }
      }
    },
  },
};
